export default fn => async (dispatch, getState) => {
	await fn(dispatch, getState)
}
